import * as React from "react";
import {
  List, Datagrid, TextField, EmailField, Show, TabbedShowLayout, SearchInput,
} from "react-admin";
import { JsonField } from "../../components/JsonField";
import { ReferralPanel } from "../../components/ReferralPanel";
import { FrDateField } from "../../components/FrDateField";

// Ambassadeurs = users de type AMBASSADOR (listFilter dans resourceMap).
// Le code ambassadeur + les parrainages viennent de /referral/dashboard.
const filters = [<SearchInput key="q" source="q" alwaysOn />];

export default {
  list: () => (
    <List
      filters={filters}
      filter={{ type: "AMBASSADOR" }}
      sort={{ field: "createdAt", order: "DESC" }}
      perPage={25}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="firstName" label="Prénom" />
        <TextField source="lastName" label="Nom" />
        <EmailField source="email" />
        <FrDateField source="createdAt" label="Inscrit le" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Identité">
          <TextField source="firstName" label="Prénom" />
          <TextField source="lastName" label="Nom" />
          <EmailField source="email" />
          <TextField source="phone" />
          <FrDateField source="createdAt" label="Inscrit le" showTime />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Parrainage">
          <ReferralPanel />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Brut">
          <JsonField source="__all__" />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  ),
};
